import { action, observable } from 'mobx'
import { Image } from './Image'
import { Product } from './Product'
import { Project } from './Project'
import { Shipping } from './Shipping'

export interface BrandDTO {
  id: number
  externalId: string
  ownerId: string
  name: string
  info: string
  websiteUrl: string
  images: Image[]
  mainImage: Image
  marketplaceType:string
  products: Product[]
  projects: Project[]
  relatedMedia: Project[]
  shippings: Shipping[]
  tags: string
  status: 'NEW'
  createdDate: Date
  loadContents: boolean
  loadProjects?: boolean
  numberProducts: number
  activeAgreementsCnt: number
  rating: number
  reviewsCnt: number
  shopifyAccessToken?: string
  shopifyStoreUrl?: string
}
export class Brand {
  id: number
  externalId: string
  ownerId: string
  name: string
  info: string
  websiteUrl: string
  images: Image[]
  mainImage: Image
  marketplaceType:string
  @observable products: Product[]
  projects: Project[]
  relatedMedia: Project[]
  shippings: Shipping[]
  tags: string
  status: 'NEW'
  createdDate: Date
  loadContents: boolean
  numberProducts: number
  activeAgreementsCnt: number
  rating: number
  reviewsCnt: number
  removable: boolean
  shopifyAccessToken?: string
  shopifyStoreUrl?: string

  constructor (brand: BrandDTO) {
    for (const property in brand) {
      switch (property) {
        // case 'products': {
        //   this[property] = brand[property].map(p => new Product(p))
        //   break
        // }
        // case 'projects':
        // case 'relatedMedia': {
        //   this[property] = brand[property].map(p => new Project(p))
        //   break
        // }
        default: {
          this[property] = brand[property]
          break
        }
      }
    }
  }

  @action setProducts = (products: Product[]) => {
    this.products = products
  }

  get imageUrl () {
    if (this.mainImage && this.mainImage.url) return this.mainImage.url
    if (this.images && this.images[0] && this.images[0].url) return this.images[0].url
    return null
  }

  get tagsAsArray () {
    return this.tags
      ? this.tags.split(',')
      : []
  }

  get projectsInfoCol (): { projectName: string, additionalCount: number } {
    if (!this.projects || !this.projects.length) {
      return {
        projectName: null,
        additionalCount: null
      }
    }

    return {
      projectName: this.projects[0].name,
      additionalCount: this.projects.length - 1
    }
  }

  get productsCount (): number {
    return (this.products || []).length
  }

  get asDTO (): BrandDTO {
    return {
      activeAgreementsCnt: this.activeAgreementsCnt,
      createdDate: this.createdDate,
      externalId: this.externalId,
      id: this.id,
      images: this.images,
      info: this.info,
      loadContents: this.loadContents,
      mainImage: this.mainImage,
      marketplaceType:this.marketplaceType,
      name: this.name,
      numberProducts: this.numberProducts,
      ownerId: this.ownerId,
      products: this.products,
      projects: this.projects,
      // projects: this.projects.map(p => p.asDTO),
      rating: this.rating,
      relatedMedia: this.relatedMedia,
      // relatedMedia: this.relatedMedia.map(p => p.asDTO),
      shippings: this.shippings,
      status: this.status,
      tags: this.tags,
      websiteUrl: this.websiteUrl,
      reviewsCnt: this.reviewsCnt,
      shopifyAccessToken : this.shopifyAccessToken,
      shopifyStoreUrl : this.shopifyStoreUrl
    }
  }
}
